import { createSelector } from 'reselect';
import { DebugOptions } from '../constants';
import { keyIn } from '../utils/immutable';
const DEBUG_OPTION_KEYS = Object.values(DebugOptions || {});
export const getDebugMode = state => state.app.get('debugMode');
export const getDebugOptions = state => state.app.filter(keyIn(...DEBUG_OPTION_KEYS)).toJS();
export const getTestMode = state => state.app.get('testMode') === 'true';
export const getJavaScriptIntegrationEnabled = state => state.app.get(DebugOptions.JAVASCRIPT_INTEGRATION);
export const getRedirectUrl = state => state.app.get('redirectUrl');
export const getFocusedFieldKeys = state => state.app.get('focusedFieldKeys').toJS();
export const getPreviewIframeLoaded = state => state.app.get('previewIframeLoaded');
export const getInitialIframeLoadExecuted = state => state.app.get('initialIframeLoadExecuted');
export const getPreviewCacheBust = state => state.app.get('previewCacheBust');
export const getPreviewTemplatePathFromProps = (state, props) => props.previewTemplatePath;
export const getPreviewPageIdFromProps = (state, props) => props.previewPageId;
export const getSelectedPreviewAssetValue = createSelector([getPreviewPageIdFromProps, getPreviewTemplatePathFromProps], (previewPageIdFromProps, selectedTemplatePath) => previewPageIdFromProps || selectedTemplatePath);
export const getIframeLoadTimedOut = state => state.app.get('iframeLoadTimedOut');
export const getFromAppName = state => state.app.get('fromAppName');
export const getBusinessUnitId = state => state.app.get('businessUnitId');
export const getPreviewiframeReady = state => state.app.get('previewIframeReady');
export const getSelectedBreakpoint = state => state.app.get('selectedBreakpoint');